import { LuneTheme, Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Image from 'next/image'
import { FC } from 'react'

import AnimatedTitle from '@/components/AnimatedTransactions/AnimatedTitle'
import FloatingChip from '@/components/AnimatedTransactions/FloatingChip'
import ReceiptTable from '@/components/AnimatedTransactions/ReceiptTable'
import useDevice from '@/hooks/useDevice'

const { palette } = LuneTheme

const ReceiptCut: FC<{ img: string }> = ({ img }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '20px',
                backgroundImage: `url(${img})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}
        />
    )
}

const Receipt: FC = () => {
    const { smScreen } = useDevice()

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexDirection: 'column',
                img: {
                    maxWidth: '100%',
                },
            }}
        >
            <AnimatedTitle title={'Enhance with AI-powered precision'} />
            <Box
                sx={{
                    filter: 'drop-shadow(0px 32px 72px rgba(4, 131, 9, 0.20))',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    maxWidth: '576px',
                    flexDirection: 'column',
                    width: '100%',
                }}
            >
                <ReceiptCut img={'/images/receipt-cut-top.png'} />
                <Box
                    sx={{
                        background: 'white',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        flexDirection: 'column',
                        padding: {
                            xs: '13px 22px',
                            md: '24px 40px',
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <Text variant={'h5'}>
                            Travel receipt <br /> from booking.com
                        </Text>
                        {smScreen ? (
                            <Image
                                width={22}
                                height={22}
                                src={'/icons/icon-booking.png'}
                                alt={'booking-icon'}
                            />
                        ) : (
                            <Image
                                width={48}
                                height={48}
                                src={'/icons/icon-booking.png'}
                                alt={'booking-icon'}
                            />
                        )}
                    </Box>
                    <ReceiptTable />
                </Box>
                <ReceiptCut img={'/images/receipt-cut-middle.png'} />
                <Box
                    sx={{
                        background: 'white',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        gap: {
                            xs: 1,
                            md: 2,
                        },
                        flexDirection: 'column',
                        padding: {
                            xs: '19px 22px 13px 22px',
                            md: '35px 40px 24px 40px',
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <Text variant={'body1'}>Included VAT</Text>
                        <Text variant={'body1'}>$ 150.87</Text>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <Text variant={'h5'}>Total</Text>
                        <FloatingChip
                            text={
                                <>
                                    476 kgCO₂e <span style={{ color: palette.Green100 }}>-17%</span>
                                </>
                            }
                            animationDelay={'2s'}
                        >
                            <Text variant={'h5'}>$ 754.36</Text>
                        </FloatingChip>
                    </Box>
                </Box>
                <ReceiptCut img={'/images/receipt-cut-bottom.png'} />
            </Box>
        </Box>
    )
}

export default Receipt
